import { Link } from "react-router-dom";  

interface EditButtonProps {
  to?: string;
  onClick?: () => void;
  className?: string;
  iconClassName?: string;
}

export const EditButton = ({ 
  to, 
  onClick,
  className = "", 
  iconClassName = "ph-pencil" 
}: EditButtonProps) => {
  const buttonStyle = {
    borderRadius: "6px",
    padding: "6px 10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(57, 105, 231, 0.1)",
    borderColor: "rgba(57, 105, 231, 0.2)",
    color: "#3969E7",
    transition: "all 0.2s ease",
    textDecoration: "none",
    width: "32px",
    height: "32px",
    cursor: "pointer",
    border: "1px solid rgba(57, 105, 231, 0.2)",
  };

  const handleMouseEnter = (e: React.MouseEvent<HTMLElement>) => {
    e.currentTarget.style.backgroundColor = "rgba(57, 105, 231, 0.2)";
    e.currentTarget.style.transform = "translateY(-1px)";
    e.currentTarget.style.boxShadow = "0 2px 4px rgba(57, 105, 231, 0.1)";
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLElement>) => {
    e.currentTarget.style.backgroundColor = "rgba(57, 105, 231, 0.1)";
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "none";
  };

  if (onClick) {
    return (
      <span
        onClick={onClick}
        className={`btn btn-sm ${className}`}
        style={buttonStyle}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <i className={iconClassName} style={{ fontSize: "14px" }}></i>
      </span>
    );
  }

  return (
    <Link
      to={to || "#"}
      className={`btn btn-sm ${className}`}
      style={buttonStyle}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <i className={iconClassName} style={{ fontSize: "14px" }}></i>
    </Link>
  );
};

